/**
 * §6.3 Business Opportunity — 6 revenue / brand levers unlocked by WL.
 */

import React from 'react'
import {
  Building2, Bot, GraduationCap, CreditCard, TrendingUp, Layers, Sparkles,
} from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import FeatureGrid from '../FeatureGrid'
import { OPPORTUNITY } from '../data'

const ICONS = { Building2, Bot, GraduationCap, CreditCard, TrendingUp, Layers, Sparkles }

export default function Opportunity() {
  return (
    <section className="relative py-24 md:py-28">
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow tone="green">Business Opportunity</Eyebrow>
          <SectionHeading align="center"
            title={<>Own the brand.{' '}<span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">Own the revenue.</span></>}
            subtitle="White-label unlocks six distinct business levers — from SaaS licensing to premium education tiers — under a single platform."
          />
        </div>
        <FeatureGrid items={OPPORTUNITY} icons={ICONS} cols={3} />
      </Container>
    </section>
  )
}
